import { CREATE_PARAM, CREATE_PARAM_SUCCESSFUL, CREATE_PARAM_FAILED } from './actionTypes';

export const createParameter = (param, history) => {
    return {
        type: CREATE_PARAM,
        payload: { param, history }
    }
}

export const createParameterSuccessful = (msg) => {
    return {
        type: CREATE_PARAM_SUCCESSFUL,
        payload: msg
    }
}

export const createParametersFailed = (msg) => {
    return {
        type: CREATE_PARAM_FAILED,
        payload: msg
    }
}
